export default "__VITE_ASSET__T45KvAMC__"